import styled from "styled-components";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";
import { baseColors } from "../../../../themes/definitions/si/cis/base-colors";
import {hexToRgba} from "../../../../themes/hex-to-rgba";

const VouchersGamesListTitleDefaultBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 1.5rem;
    padding: 10px 4px 10px 4px;
    width: 100%;

    border-bottom-width: 4px;
    border-bottom-style: solid;
    border-bottom-color: #0e0e0e;
  
    text-align: center;
`;

const VouchersGamesListTitleCasino777Box = styled(VouchersGamesListTitleDefaultBox)`
    border-top: 1px solid transparent;
    padding-top: 1.2rem;
`;

const VouchersGamesListTitleCasinoSICisBox = styled(VouchersGamesListTitleDefaultBox)`
    font-size: 1.15rem;
    ${({theme}) => theme.font.presets.thin}
    box-shadow: 0px 0px 6px ${baseColors.base08Shadow};
    background-color: ${baseColors.gray023};
`;

const VouchersGamesListTitleCasinoSIBox = styled(VouchersGamesListTitleDefaultBox)`
    ${({theme}) => theme.font.presets.thin}
`;

const VouchersGamesListTitleMrGreenBox = styled(VouchersGamesListTitleDefaultBox)`
    border-bottom: 1px solid ${({theme}) => hexToRgba(theme.colors.boxBorderLighter, 0.2)};
`;

const VouchersGamesListTitleMrGreenCisBox = styled(VouchersGamesListTitleMrGreenBox)`
    background-color: ${({theme}) => theme.colors.backgroundDark};
`;



export const VouchersGamesListTitleBox = styledByTheme(VouchersGamesListTitleDefaultBox)
    .forCasino777(VouchersGamesListTitleCasino777Box)
    .forSICis(VouchersGamesListTitleCasinoSICisBox)
    .forSI(VouchersGamesListTitleCasinoSIBox)
    .forMrGreen(VouchersGamesListTitleMrGreenBox)
    .forMrGreenCis(VouchersGamesListTitleMrGreenCisBox)
    .apply();